import functionUncurryThis from './function-uncurry-this.js';

var uncurryThis = functionUncurryThis;
var replace = uncurryThis(''.replace);

var TEST = function (arg) {
  return String(Error(arg).stack);
}('zxcasd');

var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var clearErrorStack = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string') {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  }

  return stack;
};

export { clearErrorStack as default };
